var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamationTriangleFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "pi pi-exclamation-triangle-fill",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59 1.862c.603-1.126 2.217-1.126 2.82 0l6.067 11.324A1.3 1.3 0 0 1 14.33 15.1H1.836a1.4 1.4 0 0 1-1.234-2.061L6.59 1.862Zm.66 9.888a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM8 9.6a.6.6 0 0 0 .6-.6V6.5a.6.6 0 1 0-1.2 0V9a.6.6 0 0 0 .6.6Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationTriangleFill);
export default __webpack_public_path__ + "static/media/exclamation-triangle-fill.1d6d902922530a8822e4e67ebb8d466c.svg";
export { ForwardRef as ReactComponent };